import styled from '@emotion/styled';
import { Input } from './Filters';
import IconSvg from './IconSvg';
import { colors } from '../../constants';
import { text2 } from '../../constants/classes';

export const InfoText = styled.div`
  margin: 10px 0;
  ${text2}
`;

export const PageContainer = styled.div`
  padding: 20px 2px;
`;

// Stats
export const StatsContainer = styled.div`
  min-height: 200px;

  @media (max-width: 1100px) {
    border-right: none;
  }
`;

export const StatsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-right: ${({ paddingRight }) => paddingRight || '44px'};
`;

export const StatsItem = styled.li`
  align-items: center;
  display: flex;
  height: 42px;
  margin-bottom: ${({ marginBottom }) => marginBottom || '15px'};
  width: ${({ width }) => width || '148px'};

  :nth-last-of-type(-n + 2) {
    margin-bottom: 15px;
  }
`;

export const Value = styled.span`
  font-family: 'Heebo-Thin';
  color: ${({ theme }) => theme.colors.blackSecondary};
  font-size: ${({ theme }) => theme.fontSize.huge};
  font-weight: ${({ theme }) => theme.fontWeight.veryLight};
  margin-right: 27px;
`;

export const StatsWrapper = styled.div`
  width: 378px;
  // border-right: ${({ theme }) => `2px solid ${theme.colors.greyLight}`};
`;

// Table
export const TableWrapper = styled.section`
  box-shadow: 0px 1px 7px 0 rgba(0, 105, 250, 0.07);
  border-radius: 3px;
  background-color: ${({ theme }) => theme.colors.whiteBackground};
  z-index: 10;
`;

export const CellContainer = styled.div`
  justify-content: ${({ justify }) => (justify ? 'space-between' : null)};
  display: flex;
  align-items: center;
  ${({ isVariation, color }) => !isVariation && `border-left: 4px solid ${color} !important;`}
  padding-left: 0;
  height: 42px;
`;

// Toolbar
export const Wrapper = styled.div`
  padding: 15px 10px;
`;

export const ResultCounter = styled.h3`
  font-size: 25px;
  color: ${({ theme }) => theme.colors.blackSecondary};
  font-weight: ${({ theme }) => theme.fontWeight.light};
  font-family: 'Heebo-Thin';
  margin: 0;
`;

export const ResultsLabel = styled.span`
  font-size: ${({ theme }) => theme.fontSize.small};
  font-family: 'Heebo';
  font-weight: 300;
  line-height: 1.33;
  color: ${({ theme }) => theme.colors.greySecondary};
  ${({ marginRight }) => (marginRight ? `margin-right:${marginRight}` : '')};
`;

export const SearchInput = styled(Input)`
  font-size: ${({ theme }) => theme.fontSize.small};
  color: ${({ theme }) => theme.colors.greyDark};
  line-height: ${({ theme }) => theme.lineHeight.huge};
  ${({ showIcon }) =>
    showIcon === undefined || showIcon === true
      ? `
    background: url('../../../assets/icons/search.svg') no-repeat 10px;
    background-size: 16px 16px;
    padding-left: 30px;
  `
      : ''}
`;

export const InfoRowContainer = styled.div`
  display: flex;
  text-align: left;
  ${({ nonFixedHeight }) => (nonFixedHeight ? '' : 'height: 38px;')}
`;

export const InputRow = styled('div')`
  ${({ nonFixedHeight }) => (nonFixedHeight ? '' : 'height: 38px;')}
  display: flex;
  margin-left: 25px;
  line-height: 39px;
`;

export const LabelColContainer = styled.div`
  width: ${({ width }) => width || '190px'};
  padding-right: 15px;
`;

export const Label = styled.label`
  font-size: ${({ theme }) => theme.fontSize.medium};
  color: ${({ theme }) => theme.colors.greySecondary};
  line-height: ${({ theme }) => theme.lineHeight.medium};
  font-weight: ${({ theme, bold }) => (bold ? 'bold' : theme.fontWeight.normal)};
  ${({ margin }) => (margin ? `margin: ${margin};` : '')}
`;

export const InfoValue = styled.span`
  font-size: ${({ theme }) => theme.fontSize.medium};
  color: ${({ theme }) => theme.colors.greySecondary};
  line-height: ${({ theme }) => theme.lineHeight.medium};
  font-weight: ${({ theme }) => theme.fontWeight.normal};
  height: 38px;
  display: flex;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  border-bottom: ${({ theme }) => theme.colors.borderLight} solid 1px;
  margin-bottom: 10px;
  margin-top: 10px;
`;

// for carousels
export const Arrow = styled(IconSvg)`
  &:before {
    content: none !important;
  }
  transform: ${props => (props.flip ? 'rotate(180deg)' : '')};
`;

export const BlurContainer = styled.div`
  height: 100%;
  ${({ blur }) =>
    blur &&
    `
    filter: blur(${blur}px);
    user-select: none;
    pointer-events: none;
  `}
`;

export const PopoverSquareButton = styled.button`
  width: 100%;
  height: 26px;
  border: none;
  outline: none;
  user-select: none;
  background: ${colors.blueDark};
  cursor: pointer;
  color: ${colors.whiteFont};
  position: relative;
  margin-top: 8px;

  &:hover,
  &:active {
    background: ${colors.blueMed};
  }
  &:active {
    top: 1px;
  }
`;

export const PageDisabledBlocker = styled.div`
  position: fixed;
  width: calc(100vw - 118px);
  z-index: 99;
  top: 69px;
  left: 118px;
  height: 100vh;
  background: #00000080;
`;
